import React from "react";

import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

/**
 * "Try that again" after a failed load.
 *
 * Three screens grew one of these — the job field config, prompt safety and
 * the bulk-intake consent text — and the three copies wrote the same outline
 * button at three different sizes. Note that `variant` is not a prop of the
 * plain `Button`; it spreads onto the DOM node and styles nothing, which is
 * why the classes are here.
 */
export const RetryButton = ({ onClick, disabled, children = "Try again", className = "" }) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    className={cn("rounded-lg border border-border-primary px-3 py-1.5 text-[13px] text-text-primary transition-colors hover:bg-background-tertiary/30", className)}
  >
    {children}
  </Button>
);

export default RetryButton;
